module.exports = __webpack_public_path__ + "img/通信背景图.2622b14c.png";